"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModalSelector = void 0;

var _reducerNamespace = require("settings-content-modals/data/reducerNamespace");

var getModalSelector = function getModalSelector(state) {
  return state[_reducerNamespace.reducerNamespace];
};

exports.getModalSelector = getModalSelector;